import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const BulkDeleteEvents = Loadable({
  loader: () => import('../../pages/reports/bulk_delete_events/bulk_delete_events'),
});

angular.module('gym').value('BulkDeleteEvents', BulkDeleteEvents);

const BulkDeleteEventsModal = Loadable({
  loader: () => import('../../pages/reports/bulk_delete_events/bulk_delete_events_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('BulkDeleteEventsModal', BulkDeleteEventsModal);

const BulkDeleteEventsFiltersModal = Loadable({
  loader: () => import('../../pages/reports/bulk_delete_events/bulk_delete_events_filters_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('BulkDeleteEventsFiltersModal', BulkDeleteEventsFiltersModal);
